module.exports = __webpack_public_path__ + "img/become-a-carrier.32b9da7.jpg";